// extracted by mini-css-extract-plugin
export default {"pdf_page":"PdfPage_pdf_page__N4kh3"};